<template>
  <span>
    <v-row dense>
      <v-col cols="12" v-for="chart in chartDataComputed" :key="chart.chartRef">
        <v-card-charts-dashboard
          :title="chart.title"
          :options="chart.options"
          :chart-ref="chart.chartRef"
          :deep-copy-on-update="chart.deepCopyOnUpdate"
          :is-loading="chart.loading"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  name: "DashboardFaturamentoVisaoAneelCardsKpisPorCompetencia",
  components: {
    VCardChartsDashboard: () =>
      import("@/components/base/VCardChartsDashboard.vue"),
  },
  props: {
    dados: {
      type: Object,
      required: true,
    },
    metasKpis: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    exportingOptions: {
      type: Object,
      required: true,
    },
    loading: {
      type: Object,
    },
  },
  data: () => ({
    chartPslOptions: {},
    chartPrfOptions: {},
    chartPcfOptions: {},
    chartData: [
      {
        title: "PSL - Percentual de Faturas Emitidas Sem Leitura",
          chartRef: "chartPslOptions",
          optionsProp: "chartPslOptions",
          loadingKey: "dadosKpisTotalizadosCompetenciaAnterior",
        deepCopyOnUpdate: false,
      },
      {
        title: "PRF - Percentual de Refaturamentos",
          chartRef: "chartPrfOptions",
          optionsProp: "chartPrfOptions",
          loadingKey: "dadosKpisTotalizadosCompetenciaAnterior",
        deepCopyOnUpdate: false,
      },
      {
        title: "PCF - Percentual de Acertos de Faturamento",
          chartRef: "chartPcfOptions",
          optionsProp: "chartPcfOptions",
          loadingKey: "dadosKpisTotalizadosCompetenciaAnterior",
          deepCopyOnUpdate: false,
      },
    ],
  }),
  computed: {
    chartDataComputed() {
      return this.chartData.map((chart) => {
        return {
          ...chart,
          options: this[chart.optionsProp],
          loading: !!this.loading[chart.loadingKey],
        };
      });
    },
  },
  mounted() {
    this.setChartsOptions();
  },
  methods: {
    setChartsOptions() {
      this.setChartPslOptions();
      this.setChartPrfOptions();
      this.setChartPcfOptions();
    },
    getColumnChartDefaultOptions() {
      return {
        chart: {
          type: "column",
          zoomType: "x",
          height: 300,
        },
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: true },
        xAxis: {
          categories: this.categories,
          crosshair: true,
          title: {
            text: "Competência",
          },
        },
        yAxis: {
          title: { text: null },
        },
        plotOptions: {
          column: {
            stacking: "normal",
          },
        },
        tooltip: {
          shared: true,
        },
        lang: {
          noData: "Sem dados para exibição",
        },
        series: [],
        exporting: this.exportingOptions,
      };
    },
    setChartPslOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "PSL",
          animation: false,
          data: this.categories.map((category) => {
            return category in this.dados
              ? {
                  x: this.categories.indexOf(category),
                  y: Number(this.dados[category].psl),
                }
              : { x: this.categories.indexOf(category), y: null };
          }),
          // .filter(val => val !== null && val.y !== null && val.y > 0)
        },
        {
          name: "Meta",
          animation: false,
          stickyTracking: false,
          type: "spline",
          data: this.categories
            .map((category) => {
              return category in this.metasKpis
                ? {
                    x: this.categories.indexOf(category),
                    y: Number(this.metasKpis[category].psl),
                  }
                : { x: this.categories.indexOf(category), y: null };
            })
            .filter((val) => val !== null && val.y !== null),
        },
      ];

      this.chartPslOptions = options;
    },
    setChartPrfOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "PRF",
          animation: false,
          data: this.categories.map((category) => {
            return category in this.dados
              ? {
                  x: this.categories.indexOf(category),
                  y: Number(this.dados[category].prf),
                }
              : { x: this.categories.indexOf(category), y: null };
          }),
          // .filter(val => val !== null && val.y !== null && val.y > 0)
        },
        {
          name: "Meta",
          animation: false,
          stickyTracking: false,
          type: "spline",
          data: this.categories
            .map((category) => {
              return category in this.metasKpis
                ? {
                    x: this.categories.indexOf(category),
                    y: Number(this.metasKpis[category].prf),
                  }
                : { x: this.categories.indexOf(category), y: null };
            })
            .filter((val) => val !== null && val.y !== null),
        },
      ];

      this.chartPrfOptions = options;
    },
    setChartPcfOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "PCF",
          animation: false,
          data: this.categories.map((category) => {
            return category in this.dados
              ? {
                  x: this.categories.indexOf(category),
                  y: Number(this.dados[category].pcf),
                }
              : { x: this.categories.indexOf(category), y: null };
          }),
          // .filter(val => val !== null && val.y !== null && val.y > 0)
        },
        {
          name: "Meta",
          animation: false,
          stickyTracking: false,
          type: "spline",
          data: this.categories
            .map((category) => {
              return category in this.metasKpis
                ? {
                    x: this.categories.indexOf(category),
                    y: Number(this.metasKpis[category].pcf),
                  }
                : { x: this.categories.indexOf(category), y: null };
            })
            .filter((val) => val !== null && val.y !== null),
        },
      ];

      this.chartPcfOptions = options;
    },
  },
  watch: {
    dados() {
      this.setChartsOptions();
    },
  },
};
</script>

<style></style>
